import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { RepairStageCard } from "@/components/admin/RepairStageCard";

export default function RepairJobManage({ intake, open, onOpenChange, onUpdated }) {
  const [stages, setStages] = useState([]);
  const [current, setCurrent] = useState(intake);

  useEffect(() => { setCurrent(intake); }, [intake]);

  useEffect(() => {
    if (!open) return;
    api.get("/admin/wa-stages").then((r) => setStages(r.data)).catch(() => setStages([]));
  }, [open]);

  const refreshIntake = async () => {
    // Re-fetch the intake to get updated wa_notifications history + persisted fields
    try {
      const { data } = await api.get(`/admin/repair-intakes`);
      const updated = data.find((i) => i.id === current.id);
      if (updated) {
        setCurrent(updated);
        onUpdated?.(updated);
      }
    } catch (e) {
      console.error("Failed to refresh repair intake after update:", e);
    }
  };

  if (!current) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="repair-manage-dialog" className="max-w-4xl max-h-[92vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 flex-wrap">
            <span>Repair job</span>
            <span className="font-mono text-sm text-zinc-500">{current.id}</span>
            <span className="text-zinc-400">·</span>
            <span className="text-brand">{current.name}</span>
          </DialogTitle>
          <div className="text-xs text-zinc-500 mt-1">
            {current.device} · {current.phone || "no phone"}{current.email ? ` · ${current.email}` : ""}
          </div>
        </DialogHeader>

        <div className="mt-4">
          <div className="text-xs font-bold uppercase tracking-[0.15em] text-zinc-500 mb-3">Send stage-by-stage WhatsApp updates</div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {stages.map((s) => (
              <RepairStageCard
                key={s.key}
                stage={s}
                intake={current}
                onLogged={refreshIntake}
                onIntakeSaved={(u) => { setCurrent(u); onUpdated?.(u); }}
              />
            ))}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
